import { fetchJson } from '~/utils/fetch-json-v2';
import type { AcceptInvitationResponse, Invite } from '../-types/invite';

/**
 * Fetches invite data by invite code
 * @param code - The invite code to fetch
 * @returns Promise with invite data
 */
export async function getInviteByCode(code: string): Promise<Invite> {
  const response = await fetchJson<Invite>(`/invite/${code}`);

  if (!response.data) {
    throw new Error('Invite not found');
  }

  return response.data;
}

/**
 * Accepts an invitation by invite code
 * @param code - The invite code to accept
 * @returns Promise with acceptance response
 */
export async function acceptInvitation(
  code: string,
): Promise<AcceptInvitationResponse> {
  const { data } = await fetchJson<AcceptInvitationResponse>(
    `/invite/${code}/accept`,
    {
      method: 'POST',
    },
  );

  if (!data) {
    throw new Error('No response received');
  }

  if (data.result.invite.status !== 'accepted') {
    throw new Error('No se pudo aceptar la invitación');
  }

  return data;
}
